import { motion } from "framer-motion";
import { Globe, MapPin, ArrowRight } from "lucide-react";
import { Reveal, EASE } from "./Reveal";
import { scrollToId } from "../lib/scroll";

function ModeCard({ icon: Icon, title, desc, cta, variant, testid }) {
    const online = variant === "online";
    return (
        <motion.div
            data-testid={testid}
            className={`group relative overflow-hidden rounded-3xl border p-10 transition-all duration-500 hover:-translate-y-1.5 sm:p-12 ${
                online
                    ? "border-[#D4A017]/25 bg-[radial-gradient(ellipse_at_top,rgba(212,160,23,0.1),rgba(10,10,10,0.9)_65%)] hover:border-[#F5C542]/50"
                    : "border-[#E88916]/20 bg-[radial-gradient(ellipse_at_top,rgba(232,137,22,0.09),rgba(10,10,10,0.9)_65%)] hover:border-[#E88916]/50"
            }`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.8, ease: EASE }}
        >
            <span
                className={`flex h-14 w-14 items-center justify-center rounded-full border ${
                    online ? "border-[#D4A017]/45" : "border-[#E88916]/45"
                }`}
            >
                <Icon size={22} className={online ? "text-[#F5C542]" : "text-[#E88916]"} />
            </span>
            <h3 className="mt-7 font-display text-3xl tracking-[0.12em] text-white sm:text-4xl">
                {title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#B8B8B8] sm:text-base">{desc}</p>
            <button
                data-testid={`${testid}-cta`}
                onClick={() => {
                    window.dispatchEvent(
                        new CustomEvent("prefill-training", { detail: `${title.charAt(0)}${title.slice(1).toLowerCase()} Classes` })
                    );
                    scrollToId("contact");
                }}
                className={online ? "btn-gold mt-8" : "btn-ghost mt-8"}
            >
                {cta} <ArrowRight size={15} />
            </button>
        </motion.div>
    );
}

export default function ClassModes() {
    return (
        <section data-testid="class-modes-section" className="relative py-20 sm:py-28 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal className="text-center">
                    <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#E88916]">
                        Online &amp; Offline Classes
                    </p>
                    <h2 className="mt-4 font-display text-4xl tracking-wide sm:text-5xl lg:text-6xl">
                        TRAIN YOUR <span className="text-gold-grad">WAY</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid gap-6 md:grid-cols-2">
                    <ModeCard
                        testid="mode-online"
                        icon={Globe}
                        title="ONLINE CLASSES"
                        desc="Personalized coaching from anywhere."
                        cta="Online Training"
                        variant="online"
                    />
                    <ModeCard
                        testid="mode-offline"
                        icon={MapPin}
                        title="OFFLINE CLASSES"
                        desc="Direct training and technique correction."
                        cta="Offline Training"
                        variant="offline"
                    />
                </div>
            </div>
        </section>
    );
}
